import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { FiSearch } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { compose, lifecycle, withStateHandlers } from 'recompose';
import { SearchForm } from '../components';

const SearchToggler = ({ toggleSearching, isSearching, query, updateQuery, closeSearch }) => {
  return isSearching ?
    <span id='search-toggler-form'>
      <SearchForm
        label="Search"
        searchQuery={query}
        onSearchChange={(e) => updateQuery(e.target.value)}
      />
      <MdClose id='close-icon' onClick={closeSearch} />
    </span> :
    <span id='search-toggler' className={classNames('flexbox nowrap', { isSearching })} onClick={toggleSearching}>
      <span id='search-icon'><FiSearch /></span>
      <span id='search-label'>Search</span>
    </span>
}

export default compose(
  withStateHandlers(
    {
      isSearching: false,
      query: ''
    },
    {
      toggleSearching: ({ isSearching }) => () => ({
        isSearching: !isSearching
      }),
      updateQuery: () => (query) => ({
        query
      }),
      closeSearch: () => () => ({
        query: '',
        isSearching: false
      })
    }
  ),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        toggleSearching,
        query,
        onChange
      } = this.props

      if (prevProps.query !== query) {
        if (fp.isEmpty(query)) {
          toggleSearching()
        }
        onChange(query)
      }
    }
  })
)(SearchToggler)


// WEBPACK FOOTER //
// ./src/containers/components/search-toggler.js